import { Box, Button, Checkbox, colors, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import React, { useState } from 'react';
import axios from 'axios';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import CustomInput from './CustomInput';
import { BrowserRouter, Route } from 'react-router-dom';
import { useSkyContext } from '../store/provider';
import { DEFAULT_URL } from '../constants';

const SignoutPage: React.FC = () => {
  const context = useSkyContext();
  const handleStateChange = async () => {
    console.log('state is: ', context);

    try {
      const response = await axios({
        method: 'get',
        url: `${DEFAULT_URL}logout`,

        withCredentials: true,
      });
      console.log('Server response:', response.data);
      // Navigate to the next page if login is successful
    } catch (error) {
      console.error('Error logging in:', error);
    }
  };

  return (
    <Grid container height="90vh">
      HERE
    </Grid>
  );
};

export default SignoutPage;
